import { regionCode } from '../regions.js';

// Supported product subset, not the ca-regional compiler vocabulary. These activity
// codes match the HC rows in the submission-types catalog: EU means Extraordinary
// Use (not European Union); Level-II-NC and ADS are activities under NDS.
// DINA and other REP-capable types remain unsupported until explicitly accepted.
const supported = new Set(['NDS', 'ANDS', 'SNDS', 'SANDS', 'NC', 'SNDS-C', 'LEVEL-II-NC', 'EU-NDS', 'EU-SNDS', 'ADS']);
const text = (value: unknown): string => typeof value === 'string' ? value.trim() : '';

/** Conservative human-drug scope; no inferred REP vocabulary or CTA eligibility. */
export function supportsRepWorkingCopy(submission: Readonly<Record<string, unknown>>): boolean {
  if (regionCode(text(submission.Region)) !== 'HC') return false;
  const types = [submission.ApplicationType, submission.SubmissionType, submission.SubmissionTypeCode].map(value => text(value).toUpperCase());
  if (types.some(value => value.includes('CTA'))) return false;
  const application = types[0] || types[1] || '';
  const activity = types[2] || types[1] || application;
  return supported.has(application) && supported.has(activity);
}
